import * as yup from 'yup'

type ValidationMessages = {
  password: {
    min: string
    matches: string
    identical: string
    required: string
  }
  passwordConfirmation: {
    identical: string
    required: string
  }
}

export const createResetPasswordSchema = ({
  password,
  passwordConfirmation,
}: ValidationMessages) => {
  return yup.object().shape({
    password: yup
      .string()
      .min(8, password.min)
      .matches(/[a-z]+/, password.matches)
      .matches(/[A-Z]+/, password.matches)
      .matches(/[@$!%*#?&]+/, password.matches)
      .matches(/\d+/, password.matches)
      .required(password.required),
    passwordConfirmation: yup
      .string()
      .oneOf([yup.ref('password'), null], passwordConfirmation.identical)
      .required(passwordConfirmation.required),
  })
}
